import React from 'react';

const Payment = () => {
    return (
        <div className="mt-5">
            <h2 className="mt-5">Payment System Coming Soon......</h2>
        </div>
    );
};

export default Payment;